import { Member, User } from '@quick/client';
import { env } from '../configs/EnvironmentConfig';

export const identifyIntercom = (user: User, member: Member | undefined) => {
  window.intercomSettings = {
    app_id: env.REACT_APP_INTERCOM_KEY,
    user_id: user.userId.toString(),
    email: user.email || member?.email,
    name: member?.name,
    // @ts-ignore
    memberId: member?.memberId,
    memberEmail: member?.email,
    communityId: member?.communityId,
  };
  Intercom('update');
};

export const resetIntercom = () => {
  window.intercomSettings = {
    app_id: env.REACT_APP_INTERCOM_KEY,
  };
  Intercom('shutdown');
  Intercom('boot', { app_id: env.REACT_APP_INTERCOM_KEY });
};
